import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  canResendSmsForBankConfirmation: true,
  sendSmsForBankConfirmation: {
    isSubmitted: false,
    isError: false,
    message: null,
    isRequesting: false,
  },
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_SEND_SMS_FOR_BANK_CONFIRMATION]: (state, { payload }) => ({
      ...state,
      sendSmsForBankConfirmation: payload,
    }),
    [actionTypes.UPDATE_CAN_RESEND_SMS_FOR_BANKLINK]: (state, { payload }) => ({
      ...state,
      canResendSmsForBankConfirmation: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
